<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑委外工单' : '新增委外工单'"
      width="1010px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
        <e-form ref="refForm" :column="formColumn" :data.sync="selfData.formData" />
        <div v-if="selfData.tableSaleData.length">
          <div class="group-title m-t-10">工艺路线</div>
          <div class="m-t-10">
            <GongyiLine
              :data="selfData.tableSaleData[0]"
              :isShowBom="false"
              :isShowAll="false"
              isSource
            />
          </div>
          <div class="group-title m-t-20">物料清单</div>
          <div class="m-t-10">
            <TableWuliao :data.sync="selfData.wuliaoData" />
          </div>
          <div class="group-title m-t-20">工艺详情</div>
          <div class="m-t-10">
            <TableGongyi :data.sync="selfData.gongyiData" />
          </div>
          <div class="group-title m-t-20">成品</div>
          <div class="m-t-10">
            <TableChengpin :list="selfData.tableSaleData" />
          </div>
          <div class="group-title m-t-20">质检要求</div>
          <div class="m-t-10">
            <table class="zhijian-table">
              <thead>
                <tr>
                  <th width="60">序号</th>
                  <th>检测项目</th>
                  <th>标准范围</th>
                  <th>实测范围</th>
                  <th>检测结果</th>
                  <th width="120">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selfData.zhi_jian_yao_qiu_list" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td><el-input v-model="item.jian_ce_xiang_mu" size="mini" /></td>
                  <td><el-input v-model="item.biao_zhun_fan_wei" size="mini" /></td>
                  <td><el-input v-model="item.shi_ce_fan_wei" size="mini" /></td>
                  <td><el-input v-model="item.jian_ce_jie_guo" size="mini" /></td>
                  <td>
                    <el-link type="success" @click="addZhijian(index)">增行</el-link>
                    <el-link
                      v-if="selfData.zhi_jian_yao_qiu_list.length > 2"
                      class="m-l-10"
                      type="danger"
                      @click="removeZhijian(index)"
                      >删行</el-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" @click="popupConfirm(true)">打印预览</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    GongyiLine: () => import('@/components/business/b-popup-verify-goods-view/view-item'),
    TableWuliao: () => import('./table-wuliao'),
    TableGongyi: () => import('./table-gongyi'),
    TableChengpin: () => import('./table-chengpin')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    billId: {
      type: [Number, String],
      default: ''
    },
    jiagongId: {
      type: [Number, String],
      default: ''
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      // 供应商完整数据列表，用于联动查询联系人与电话
      supplierList: [],
      selfData: {
        formData: {
          id: '',
          gong_dan_code: '',
          bill_id: '',
          bill_code: '',
          gong_cheng_fu_ze_ren_name: '',
          pmc_fu_ze_ren_name: '',

          fu_ze_ren_id: '',
          processor_name: '',
          processor_fu_ze_ren: '',
          processor_phone: '',
          jiao_huo_ri_qi: '',
          sheng_chan_end_date: '',
          check_stock2_id: '',
          current_gong_xu_id: ''
        },
        tableSaleData: [],
        wuliaoData: [],
        gongyiData: {},
        zhi_jian_yao_qiu_list: []
      },
      formColumn: [
        {
          type: 'text',
          title: '工单编码',
          field: 'gong_dan_code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          disabled: true
        },
        {
          type: 'text',
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'text',
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'select',
          title: '负责人',
          field: 'fu_ze_ren_id',
          options: []
        },
        {
          type: 'autocomplete',
          title: '加工商',
          field: 'processor_name',
          // 供应商建议列表：输入时实时过滤，可不匹配自由输入
          querySearch: (queryString, callback) => {
            let list = this.supplierList.map((item) => ({ value: item.supplier_name }))
            let result = queryString
              ? list.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()))
              : list
            callback(result)
          }
        },
        {
          type: 'text',
          title: '加工商负责人',
          field: 'processor_fu_ze_ren'
        },
        {
          type: 'text',
          title: '加工商电话',
          field: 'processor_phone'
        },
        {
          type: 'date',
          title: '订单交期',
          field: 'jiao_huo_ri_qi'
        },
        {
          type: 'date',
          title: '生产交期',
          field: 'sheng_chan_end_date'
        }
      ]
    }
  },
  computed: {
    maxHeight() {
      return `${this.$util.getViewHeight() - 280}px`
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 监听加工商变化，联动填充负责人与电话
    // 匹配到下拉项时带出联系人/电话；未匹配（手动输入）时保留现有值由用户自行填写
    'selfData.formData.processor_name'(val) {
      if (val && this.supplierList.length) {
        let target = this.supplierList.find((item) => item.supplier_name === val)
        if (target) {
          this.selfData.formData.processor_fu_ze_ren = target.linkman || ''
          this.selfData.formData.processor_phone = target.linkman_phone || ''
        }
      } else if (!val) {
        // 清空加工商时同步清空负责人与电话
        this.selfData.formData.processor_fu_ze_ren = ''
        this.selfData.formData.processor_phone = ''
      }
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.getPmcDetailData()
    }
    this.getYuangongList()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/weiWaiGongDan/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.selfData = {
            formData: {
              ...this.selfData.formData,
              ...result.formData
            },
            tableSaleData: result.tableSaleData,
            wuliaoData: this.getWuliaoData(result.tableSaleData[0]),
            gongyiData: result.gongyiData,
            zhi_jian_yao_qiu_list: result.zhi_jian_yao_qiu_list || this.getDefaultZhijianList()
          }
          // 获取加工类型关联的供应商列表
          let bindId = result.gongyiData && result.gongyiData.bind_id
          this.getSupplierList(bindId)
        }
      })
    },
    // 获取pmc详情数据
    async getPmcDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/weiWaiGongDan/findByBillIdAndGongyiId',
        params: {
          billId: this.billId,
          gongyiId: this.jiagongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.selfData = {
            formData: {
              ...this.selfData.formData,
              ...result.formData,
              bill_id: result.formData.id,
              check_stock2_id: result.tableSaleData[0].id,
              current_gong_xu_id: this.jiagongId
            },
            tableSaleData: result.tableSaleData,
            wuliaoData: this.getWuliaoData(result.tableSaleData[0]),
            gongyiData: result.gongyiData,
            zhi_jian_yao_qiu_list: this.getDefaultZhijianList()
          }
          // 获取加工类型关联的供应商列表
          let bindId = result.gongyiData && result.gongyiData.bind_id
          this.getSupplierList(bindId)
        }
      })
    },
    // 获取物料数据
    getWuliaoData(data) {
      let result = []
      if (data.tableBomData.length) {
        result = data.tableBomData || []
      } else if (data.table_data_2.length) {
        result = data.table_data_2 || []
      } else {
        result = data.table_data_1 || []
      }
      return this.$util.deepCopy(result)
    },
    // 获取默认质检要求列表（2行空数据）
    getDefaultZhijianList() {
      return [
        { jian_ce_xiang_mu: '', biao_zhun_fan_wei: '', shi_ce_fan_wei: '', jian_ce_jie_guo: '' },
        { jian_ce_xiang_mu: '', biao_zhun_fan_wei: '', shi_ce_fan_wei: '', jian_ce_jie_guo: '' }
      ]
    },
    // 添加质检要求行（在指定位置后插入）
    addZhijian(index) {
      this.selfData.zhi_jian_yao_qiu_list.splice(index + 1, 0, {
        jian_ce_xiang_mu: '',
        biao_zhun_fan_wei: '',
        shi_ce_fan_wei: '',
        jian_ce_jie_guo: ''
      })
    },
    // 删除质检要求行（保留最少2行）
    removeZhijian(index) {
      if (this.selfData.zhi_jian_yao_qiu_list.length <= 2) return
      this.selfData.zhi_jian_yao_qiu_list.splice(index, 1)
    },
    // 获取员工列表
    getYuangongList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/yuanGong2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.yuan_gong_user_name,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'fu_ze_ren_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    /**
     * 获取供应商列表（加工商 autocomplete 数据源与联动查询）
     * 根据工艺绑定的加工模板ID（bind_id）筛选出含有对应加工类型的供应商
     * @param {Number|String} bindId - 工艺绑定的加工模板ID，对应供应商 process_type_list[].id
     */
    getSupplierList(bindId) {
      // 组装筛选参数，按加工类型ID过滤供应商
      let filterData = {}
      if (bindId) {
        filterData.process_type_id = bindId
      }
      this.$api({
        method: 'post',
        url: '/admin/supplier',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          },
          filterData
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            let list = res.data.page.list || []
            // 前端兜底过滤：确保只保留 process_type_list 中包含 bindId 的供应商
            // 若后端已正确过滤则此步结果不变，作为兼容处理
            if (bindId) {
              list = list.filter((item) => {
                if (item.process_type_list && item.process_type_list.length) {
                  return item.process_type_list.some((pt) => String(pt.id) === String(bindId))
                }
                return false
              })
            }
            // 保存完整数据用于 autocomplete 建议与负责人/电话联动
            this.supplierList = list
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 项-打印预览（保存成功后调用）
    itemPrint(id) {
      window.open(`/new/weiwai/print?id=${id}`, '_blank')
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认（isPrint 为 true 时保存成功后打印预览）
    popupConfirm(isPrint = false) {
      let { formData, gongyiData, wuliaoData } = this.selfData
      let form_data = {
        bill_id: formData.bill_id,
        check_stock2_id: formData.check_stock2_id,
        current_gong_xu_id: formData.current_gong_xu_id,
        fu_ze_ren_id: formData.fu_ze_ren_id,
        processor_name: formData.processor_name,
        processor_fu_ze_ren: formData.processor_fu_ze_ren,
        processor_phone: formData.processor_phone,
        jiao_huo_ri_qi: formData.jiao_huo_ri_qi,
        sheng_chan_end_date: formData.sheng_chan_end_date,
        gongyiData: this.$util.deepCopy(gongyiData),
        zhi_jian_yao_qiu_list: this.selfData.zhi_jian_yao_qiu_list
      }
      // 组装物料数据
      if (wuliaoData.length) {
        form_data.wuliaoData = wuliaoData.map((item) => {
          return {
            id: item.id,
            tabletype: item.tabletype,
            warehuose_name: item.warehuose_name,
            get_counts: item.get_counts
          }
        })
      }
      if (this.detailId) form_data.id = this.detailId
      this.$api({
        method: 'post',
        url: '/admin/gcvip/weiWaiGongDan/saveOrUpdate',
        data: {
          form_data
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            // 新增时取后端返回的 id，编辑时兜底用 detailId
            let printId = res.data.id || this.detailId
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
            if (isPrint === true) this.itemPrint(printId)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}

.zhijian-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ebeef5;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #f5f7fa;
  }

  /deep/ .el-input {
    width: 100%;
  }
}
</style>
